const { upgradeArray } = require('../utils')

const EVENTSHISTORY_TYPES = upgradeArray([ 'created', 'updated', 'removed', 'imported' ])

const EVENTSHISTORY_SERVICES = upgradeArray([
  'billings',
  'contactLists',
  'contacts',
  'credentials',
  'keywordLists',
  'keywords',
  'patterns',
  'providers',
  'providerGroups',
  'requisites',
  'recurrentPayments',
  'routingRules',
  'routingGroups',
  'messageRules',
  'messageRuleGroups',
  'sendernames',
  'servers',
  'tariffs',
  'tasks',
  'templates',
  'tokens',
  'users'
])

const EXCLUDE_EVENTSHISTORY_SERVICES_FOR_ASSOCIATED = [ 'billings', 'contacts', 'keywords', 'tokens' ]

const EVENTSHISTORY_ASSOCIATED_SERVICES = upgradeArray([
  ...EVENTSHISTORY_SERVICES.filter(service => !~EXCLUDE_EVENTSHISTORY_SERVICES_FOR_ASSOCIATED.indexOf(service)),
  'billingsUsers',
  'contactListsContacts',
  'keywordListsKeywords',
  'permissionsUsers',
  'settingsUserUsers',
  'tokensUsers'
])

module.exports = {
  EVENTSHISTORY_TYPES,
  EVENTSHISTORY_SERVICES,
  EVENTSHISTORY_ASSOCIATED_SERVICES,
  EXCLUDE_EVENTHISTORY_SERVICES_FOR_ASSOCIATED: EXCLUDE_EVENTSHISTORY_SERVICES_FOR_ASSOCIATED
}
